import { useState } from "react";
import FormSignIn from "./FormSignIn";
import { Form } from "react-final-form";

export default function RegisterPassword({ loading, onSubmit }) {

    const [error, setError] = useState(false)

    const isFormFieldValid = (meta) => !!(meta.touched && meta.error);

    const validate = (data) => {
        let errors = {}
        if (!data.password) {
            errors.password = "Contraseña requerida";
        }
        if (!data.confirmPassword) {
            errors.confirmPassword = "Confirmacion requerida";
        }
        if (data.password != data.confirmPassword) {
            errors.confirmPassword = "Contraseñas no coinciden";
        }
        return errors
    }

    const handleSubmit = (data, form) => {
        // form.restart()
        if (data.password === data.confirmPassword) {
            if (onSubmit) onSubmit(data)
        }
    }
    
    const getFormErrorMessage = (meta) => {
        return (
            isFormFieldValid(meta) && <small className="p-error flex text-left">{meta.error}</small>
        )
    }

    return (
        <Form
            onSubmit={handleSubmit}
            initialValues={{ email: "", password: "" }}
            validate={validate}
            render={({ handleSubmit }) => (
                <FormSignIn
                    type="register_password"
                    error={error}
                    loading={loading}
                    isFormFieldValid={isFormFieldValid}
                    getFormErrorMessage={getFormErrorMessage}
                    handleSubmit={handleSubmit}
                />
            )}
        />
    )
}